import { injectable, inject } from 'inversify';
import { CommandHandler, createCommand } from '@/app/tracking/api';
import { AddSectionDurationCommand, AddSectionDurationCommandPayload } from '../api';
import { SectionSuspendDataStateStore } from './section-suspend-data-state-store';

@injectable()
export class AddSectionDurationCommandHandler implements CommandHandler<AddSectionDurationCommand> {

  constructor(
    @inject(SectionSuspendDataStateStore)
    private readonly store: SectionSuspendDataStateStore) {
  }

  public async execute(payload: AddSectionDurationCommandPayload) {
    await this.store.execute(createCommand<AddSectionDurationCommand>('add-section-duration', payload));
  }

}
